import View from '../View';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {smokeGrey} from './Bootflow';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Cart Footer',
  showEmpty: true,
  constraints: {
    ancestors: [{is: 'CommerceCartForm', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          paddingTop: px(16),
          paddingBottom: px(24),
          paddingLeft: px(24),
          paddingRight: px(24),
          flexDirection: 'column',
          flexGrow: 0,
          flexShrink: 0,
          flexBasis: 'auto',
          borderTopStyle: 'solid',
          borderTopWidth: px(1),
          borderTopColor: smokeGrey,
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
